export type ProductMenuItem = {
  id: string;
  name: string;
};

export type ProductMenuGroup = {
  id: string;
  name: string;
  items: ProductMenuItem[];
};

export type ProductMenuCategory = {
  id: string;
  name: string;
  groups: ProductMenuGroup[];
};

/*
 * TAXONOMY CỐ ĐỊNH CỦA KING JADES
 *
 * Header và Admin Add Product cùng dùng file này.
 * Không tạo / xóa category trong màn hình Add Product nữa.
 *
 * Product vẫn lưu 4 field hiện có:
 *
 * parentCategoryId
 * parentCategoryName
 * categoryId
 * categoryName
 *
 * Group chỉ dùng để tổ chức UI/menu; có thể suy ra từ categoryId.
 */
export const PRODUCT_MENU: ProductMenuCategory[] = [
  {
    id: "vong-ngoc-thien-nhien",
    name: "Vòng Ngọc Thiên Nhiên",
    groups: [
      {
        id: "vong-ngoc-thien-nhien-items",
        name: "",
        items: [
          {
            id: "vong-ngoc-son-thuy",
            name: "Vòng Ngọc Sơn Thủy",
          },
          {
            id: "vong-ngoc-phi-thuy",
            name: "Vòng Ngọc Phỉ Thúy",
          },
          {
            id: "vong-ngoc-tu-nham",
            name: "Vòng Ngọc Tụ Nham",
          },
          {
            id: "vong-lam-ngoc",
            name: "Vòng Lam Ngọc",
          },
          {
            id: "vong-ngoc-bich",
            name: "Vòng Ngọc Bích",
          },
          {
            id: "vong-ngoc-huyet",
            name: "Vòng Ngọc Huyết",
          },
          {
            id: "vong-ngoc-hoa-dien",
            name: "Vòng Ngọc Hòa Điền",
          },
          {
            id: "vong-bach-ngoc",
            name: "Vòng Bạch Ngọc",
          },
          {
            id: "vong-ngoc-vip",
            name: "Vòng Ngọc VIP",
          },
        ],
      },
    ],
  },

  {
    id: "trang-suc-ngoc",
    name: "Trang Sức Ngọc",
    groups: [
      {
        id: "phat-ngoc",
        name: "Phật Ngọc",
        items: [
          {
            id: "duc-chua",
            name: "Đức Chúa",
          },
          {
            id: "phat-ba-quan-am",
            name: "Phật Bà Quan Âm",
          },
          {
            id: "phat-di-lac",
            name: "Phật Di Lặc",
          },
          {
            id: "phat-adida",
            name: "Phật Adida",
          },
          {
            id: "phat-ban-menh",
            name: "Phật Bản Mệnh",
          },
        ],
      },

      {
        id: "chuoi-ngoc",
        name: "Chuỗi Ngọc",
        items: [
          {
            id: "chuoi-ngoc-deo-tay",
            name: "Chuỗi Ngọc Đeo Tay",
          },
          {
            id: "chuoi-ngoc-deo-co",
            name: "Chuỗi Ngọc Đeo Cổ",
          },
        ],
      },

      {
        id: "trang-suc-ngoc-group",
        name: "Trang Sức Ngọc",
        items: [
          {
            id: "ngoc-hoa-dien",
            name: "Ngọc Hòa Điền",
          },
          {
            id: "nhan-ngoc",
            name: "Nhẫn Ngọc",
          },
          {
            id: "day-chuyen-ngoc",
            name: "Dây Chuyền Ngọc",
          },
          {
            id: "bong-tai-ngoc",
            name: "Bông Tai Ngọc",
          },
          {
            id: "vong-ngoc",
            name: "Vòng Ngọc",
          },
        ],
      },

      {
        id: "trang-suc-da-quy",
        name: "Trang Sức Đá Quý",
        items: [
          {
            id: "nhan-da-quy",
            name: "Nhẫn",
          },
          {
            id: "day-chuyen-da-quy",
            name: "Dây Chuyền",
          },
          {
            id: "bong-tai-da-quy",
            name: "Bông Tai",
          },
        ],
      },

      {
        id: "trang-suc-phong-thuy",
        name: "Trang Sức Phong Thủy",
        items: [
          {
            id: "chuoi-thach-anh",
            name: "Chuỗi Thạch Anh",
          },
        ],
      },

      {
        id: "tuong-ngoc-dieu-khac",
        name: "Tượng Ngọc Điêu Khắc",
        items: [
          {
            id: "tuong-ngoc-dieu-khac",
            name: "Tượng Ngọc Điêu Khắc",
          },
        ],
      },
    ],
  },
];

const normalizeText = (
  value?: string | null
) =>
  (value || "")
    .trim()
    .toLocaleLowerCase("vi");

export const getProductMenuCategory = (
  categoryId?: string | null
) =>
  PRODUCT_MENU.find(
    (category) =>
      category.id ===
      (categoryId || "").trim()
  );

export const getProductMenuCategoryByName = (
  name?: string | null
) =>
  PRODUCT_MENU.find(
    (category) =>
      normalizeText(
        category.name
      ) ===
      normalizeText(name)
  );

export const getProductMenuGroup = (
  parentCategoryId?: string | null,
  groupId?: string | null
) =>
  getProductMenuCategory(
    parentCategoryId
  )?.groups.find(
    (group) =>
      group.id ===
      (groupId || "").trim()
  );

export const getAllProductMenuItems = (
  category:
    ProductMenuCategory
) =>
  category.groups.flatMap(
    (group) =>
      group.items.map(
        (item) => ({
          ...item,
          groupId:
            group.id,
          groupName:
            group.name,
        })
      )
  );

export const resolveProductMenuSelection = (
  input: {
    parentCategoryId?: string | null;
    parentCategoryName?: string | null;
    categoryId?: string | null;
    categoryName?: string | null;
  }
) => {
  const parent =
    getProductMenuCategory(
      input.parentCategoryId
    ) ||
    getProductMenuCategoryByName(
      input.parentCategoryName
    );

  const searchCategories =
    parent
      ? [parent]
      : PRODUCT_MENU;

  for (
    const category
    of searchCategories
  ) {
    for (
      const group
      of category.groups
    ) {
      const item =
        group.items.find(
          (candidate) =>
            (
              input.categoryId &&
              candidate.id ===
                input.categoryId.trim()
            ) ||
            (
              input.categoryName &&
              normalizeText(
                candidate.name
              ) ===
                normalizeText(
                  input.categoryName
                )
            )
        );

      if (item) {
        return {
          category,
          group,
          item,
        };
      }
    }
  }

  return null;
};

export const buildProductCategoryUrl = (
  category:
    ProductMenuCategory,
  item?:
    ProductMenuItem
) => {
  const params =
    new URLSearchParams();

  params.set(
    "parentCategoryId",
    category.id
  );

  params.set(
    "parentCategory",
    category.name
  );

  if (item) {
    params.set(
      "categoryId",
      item.id
    );

    params.set(
      "category",
      item.name
    );
  }

  return `/products?${params.toString()}`;
};
